<template>
  <PhotoSwipe
    class="kpb-gallery"
    :data-kpb-variant="variant"
    :wrapper="layoutComponent"
    v-bind="$attrs"
    :data="contentComp"
    child-class="kpb-gallery__item"
  ></PhotoSwipe>
</template>

<script>
import PhotoSwipe from './Photoswipe.vue'

import Columns from './Columns.vue'
import Grid from './Grid.vue'

const LayoutComponents = {
  masonry: Columns,
  grid: Grid,
}

/** Gallery component */
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        images: [],
        content: [],
      }),
    },
    variant: {
      type: String,
      default: 'grid',
      enums: ['grid', 'masonry'],
    },
  },

  computed: {
    layoutComponent() {
      return LayoutComponents[this.variant]
    },

    contentComp() {
      return this.$path('content', this.data) || this.$path('images', this.data)
    },
  },

  components: {
    PhotoSwipe,
    Columns,
    Grid,
  },
}
</script>

<style lang="scss"></style>
